module.exports = __webpack_public_path__ + "static/chat-0f2853526ff3dbe0064c0afe75f6b618.png";